import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { sessionQueryKey } from './auth';
import { ApiError } from './client';

/**
 * QueryClient della web app. Un 401 su qualunque chiamata (sessione scaduta, revocata, persona
 * rimossa dal team) azzera la sessione in cache: `RequireSession` porta subito alla pagina di
 * accesso invece di lasciare l'interfaccia piena di errori.
 */
export function createQueryClient(options: { retry?: number | boolean } = {}): QueryClient {
  const onError = (error: unknown) => {
    if (error instanceof ApiError && error.status === 401) client.setQueryData(sessionQueryKey, null);
  };
  const client = new QueryClient({
    defaultOptions: { queries: { retry: options.retry ?? 1 } },
    queryCache: new QueryCache({ onError }),
    mutationCache: new MutationCache({ onError }),
  });
  return client;
}
